import clearSelectedConversationInModule from '../actions/clearSelectedConversationInModule';
import closeItemReadingPane from '../actions/closeItemReadingPane';
import goBackToListView from 'mini-mail-list-store/lib/actions/goBackToListView';
import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import signalReadingPaneClosed from '../actions/signalReadingPaneClosed';
import { getReadingPaneStore } from '../store/Store';
import { lazyHideBottomSheet } from 'mini-bottom-sheet-animated';

export default function closeReadingPane(): void {
    signalReadingPaneClosed();
    if (isItemView()) {
        lazyHideBottomSheet.importAndExecute();
        closeItemReadingPane();
        goBackToListView();
    } else {
        if (getReadingPaneStore().itemReadingPaneViewState) {
            closeItemReadingPane();
        } else {
            clearSelectedConversationInModule();
            lazyHideBottomSheet.importAndExecute();
        }
    }
}
